/* esm.sh - lib0@0.2.117/conditions */
var e=n=>n===void 0?null:n;export{e as undefinedToNull};
//# sourceMappingURL=conditions.mjs.map